import {
  CheckInData,
  CheckInvitationData,
  CheckInvitationParams,
  CheckinParams,
  GeneralData,
  ScanQRCodeData,
  ScanQRCodeParams,
} from './types';

import { axiosInstance, axiosInstanceV2 } from 'services/common/instance';

export const getGeneralService = async (): Promise<GeneralData> => {
  const response = await axiosInstance.get('systems/general');
  return response.data.data;
};

export const checkInvitationService = async (
  data: CheckInvitationParams
): Promise<CheckInvitationData> => {
  const response = await axiosInstance.post('members/check-invitation-checkin', data);
  return response.data.data;
};

export const checkInvitationServiceV2 = async (
  data: CheckInvitationParams
): Promise<CheckInvitationData> => {
  const response = await axiosInstanceV2.post('members/check-invitation-checkin', data);
  return response.data.data;
};

export const checkinService = async (data: CheckinParams): Promise<CheckInData> => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (typeof value === 'object') {
      formData.append(key, value);
    } else if (typeof value === 'boolean') {
      if (value) {
        formData.append(key, '1');
      } else {
        formData.append(key, '0');
      }
    } else if (value) {
      formData.append(key, value.toString());
    }
  });

  const response = await axiosInstance.post('members/check-in', formData);
  return response.data.data;
};

export const checkinServiceV2 = async (data: CheckinParams): Promise<CheckInData> => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (typeof value === 'object') {
      formData.append(key, value);
    } else if (typeof value === 'boolean') {
      if (value) {
        formData.append(key, '1');
      } else {
        formData.append(key, '0');
      }
    } else if (value) {
      formData.append(key, value.toString());
    }
  });

  const response = await axiosInstanceV2.post('members/check-in', formData);
  return response.data.data;
};

export const scanQRCodeService = async (
  data: ScanQRCodeParams
): Promise<ScanQRCodeData> => {
  const response = await axiosInstance.post('members/scan-qr-code', data);
  return response.data.data;
};

export const checkinQrcodeServiceV2 = async (
  code: string
): Promise<CheckInvitationData> => {
  const response = await axiosInstanceV2.get(`members/check-in/${code}`);
  return response.data.data;
};

export const confirmQrcodeServiceV2 = async (
  code: string
): Promise<CheckInvitationData> => {
  const response = await axiosInstanceV2.post(`members/check-in/${code}`);
  return response.data.data;
};

export const resendSMSQrCodeServiceV2 = async (
  data: CheckInvitationParams
): Promise<CheckInvitationData> => {
  const response = await axiosInstanceV2.post('members/resend-sms-check-in', data);
  return response.data.data;
};
